import React from "react";
import { ImageIcon, Play } from "lucide-react";

type MediaPreviewProps = {
    mediaUrl?: string | null;
    mediaType?: string | null;
    className?: string | null;
    thumbnail?: string | null;
};

export const MediaPreview: React.FC<MediaPreviewProps> = ({
    mediaUrl,
    mediaType,
    thumbnail,
    className = "h-12 w-12",
}) => {

    return (
        <div
            className={`relative ${className} shrink-0 overflow-hidden rounded-md border border-slate-200 bg-white grid place-items-center`}
        >
            {/* No media */}
            {!mediaUrl && !thumbnail && <ImageIcon className="h-5 w-5 text-slate-400" />}

            {/* Image */}
            {mediaUrl && mediaType === "image" && (
                <img
                    src={mediaUrl}
                    alt="Attachment"
                    className="h-full w-full object-cover"
                    loading="lazy"
                />
            )}
            {thumbnail && mediaType == 'album' && (
                <img
                    src={thumbnail}
                    alt="Attachment"
                    className="h-full w-full "
                    loading="lazy"
                />
            )}


            {/* Video */}
            {mediaUrl && mediaType === "video" && (
                <div className="relative w-full h-full">
                    <video
                        src={mediaUrl}
                        className="h-full w-full object-cover"
                        muted
                        preload="metadata"
                    />
                    <div className="absolute inset-0 flex items-center justify-center bg-black/20">
                        <Play className="h-6 w-6 text-white drop-shadow" />
                    </div>
                </div>
            )}
        </div>
    );
};